/**
 * Utilidades de exportación cliente — CSV y JSON.
 *
 * Generan un Blob y disparan la descarga en el navegador.  Compartido
 * por todas las vistas para que los botones "Exportar" produzcan un
 * archivo real en vez de quedar muertos.
 */

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportRowsToCsv(
  filename: string,
  rows: Array<Record<string, unknown>>,
): boolean {
  if (rows.length === 0) return false;
  const headers = Object.keys(rows[0]);
  const escape = (v: unknown): string => {
    const s = v === null || v === undefined ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const body = [
    headers.join(","),
    ...rows.map((row) => headers.map((h) => escape(row[h])).join(",")),
  ].join("\n");
  triggerDownload(new Blob([body], { type: "text/csv;charset=utf-8" }), filename);
  return true;
}

export function exportToJson(filename: string, data: unknown): void {
  triggerDownload(
    new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }),
    filename,
  );
}

/**
 * Genera un "PDF" simple (texto plano dentro de un PDF mínimo válido)
 * para la ficha de un caso/alerta.  Suficiente para que el botón
 * produzca un archivo abrible; en producción se reemplaza por un
 * render server-side.
 */
export function exportTextPdf(filename: string, title: string, lines: string[]): void {
  const content = [title, "", ...lines].join("\n");
  // Minimal single-page PDF with the content as a text stream.
  const escaped = content.replace(/[()\\]/g, "\\$&");
  const textObj = `BT /F1 11 Tf 48 760 Td 14 TL (${escaped.split("\n").join(") Tj T* (")}) Tj ET`;
  const objs = [
    "%PDF-1.4",
    "1 0 obj<</Type/Catalog/Pages 2 0 R>>endobj",
    "2 0 obj<</Type/Pages/Kids[3 0 R]/Count 1>>endobj",
    "3 0 obj<</Type/Page/Parent 2 0 R/MediaBox[0 0 595 842]/Resources<</Font<</F1 4 0 R>>>>/Contents 5 0 R>>endobj",
    "4 0 obj<</Type/Font/Subtype/Type1/BaseFont/Helvetica>>endobj",
    `5 0 obj<</Length ${textObj.length}>>stream\n${textObj}\nendstream endobj`,
    "trailer<</Root 1 0 R>>",
    "%%EOF",
  ].join("\n");
  triggerDownload(new Blob([objs], { type: "application/pdf" }), filename);
}
